import * as React from 'react';
import * as classNames from 'classnames';
import * as styles from './styles.scss';
import { BrokerFunction, IAccount } from 'interfaces/common';
import { Fallback } from 'components/common';
import { IState } from 'redux/global-reducers';
import { SystemType } from 'constants/enum';
import { WithNamespaces, withNamespaces } from 'react-i18next';
import { changeAccount } from 'redux/global-actions';
import { connect } from 'react-redux';
import { doBrokerVerifyPin } from 'redux/global-actions/Broker';
import { handleError } from 'utils/common';
import { withErrorBoundary } from 'react-error-boundary';

export const regexCheckPhoneCode = /^[0-9]+$/;

export interface IBrokerPhoneCodeProps
  extends React.ClassAttributes<BrokerPhoneCodeComp>,
    WithNamespaces {
  readonly isForm?: boolean;
  readonly accountList: IState['accountList'];
  readonly selectedAccount: IState['selectedAccount'];
  readonly brokerVerifyPin: IState['brokerVerifyPin'];
  readonly isAccountChanged?: boolean;
  readonly unshowAccounts?: string[];
  readonly isSelectedAll?: boolean;
  readonly isNavBarComponent?: boolean;
  readonly type?: SystemType;
  readonly brokerFunction?: BrokerFunction;
  readonly vertical?: boolean;

  readonly changeAccount: typeof changeAccount;
  readonly doBrokerVerifyPin: typeof doBrokerVerifyPin;
  readonly onChange?: (account?: IAccount | string) => void;
}

export interface IBrokerPhoneCodeState {
  readonly selectedAccount: IState['selectedAccount'];
  readonly isSelectedAllAccounts?: boolean;
  readonly phoneCode?: string;
  readonly phoneCodeError?: boolean;
}

class BrokerPhoneCodeComp extends React.Component<
  IBrokerPhoneCodeProps,
  IBrokerPhoneCodeState
> {
  static defaultProps = {
    isAccountChanged: true,
  };

  constructor(props: IBrokerPhoneCodeProps) {
    super(props);

    this.state = {
      selectedAccount: null,
      isSelectedAllAccounts: false,
    };
  }

  render() {
    const { t } = this.props;

    return (
      <div className={classNames(styles.BrokerPhoneCode)}>
        <div className={styles.PhoneCode}>
          <div>
            <span>{t('Phone Code')}</span>
            <form action="" onSubmit={this.handleSubmitPhoneCode}>
              <input
                type="text"
                onChange={this.onPhoneCodeChange}
                onBlur={this.onPhoneCodeBlur}
              />
              <input type="submit" hidden />
            </form>
          </div>
          <div>
            {this.state.phoneCodeError && (
              <div className={styles.ErrorPhoneCode}>
                {this.props.t('PHONECODE_SHOULD_BE_NUMBER')}
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }

  private handleSubmitPhoneCode = (e: React.ChangeEvent<HTMLFormElement>) => {
    e.preventDefault();
    if (
      this.state.phoneCode &&
      regexCheckPhoneCode.test(this.state.phoneCode) &&
      !this.state.phoneCodeError &&
      this.props.selectedAccount?.clientID
    ) {
      this.props.doBrokerVerifyPin({
        brokerFunction: this.props.brokerFunction,
        pin: this.state.phoneCode,
        clientID: this.props.selectedAccount?.clientID,
      });
    } else {
      if (
        this.state.phoneCode &&
        !regexCheckPhoneCode.test(this.state.phoneCode)
      ) {
        this.setState({ phoneCodeError: true });
      }
    }
  };

  private onPhoneCodeBlur = () => {
    if (
      this.state.phoneCode &&
      regexCheckPhoneCode.test(this.state.phoneCode)
    ) {
      this.setState({ phoneCodeError: false });
    } else {
      this.setState({ phoneCodeError: true });
    }
  };
  private onPhoneCodeChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    this.setState({ phoneCode: e.target.value, phoneCodeError: false });
  };
}

const mapStateToProps = (state: IState) => ({
  accountList: state.accountList,
  selectedAccount: state.selectedAccount,
  brokerVerifyPin: state.brokerVerifyPin,
});

const mapDispatchToProps = {
  changeAccount,
  doBrokerVerifyPin,
};

const BrokerPhoneCode = withErrorBoundary(
  withNamespaces('common')(
    connect(mapStateToProps, mapDispatchToProps)(BrokerPhoneCodeComp)
  ),
  Fallback,
  handleError
);

export default BrokerPhoneCode;



// WEBPACK FOOTER //
// ./src/components/common/BrokerPhoneCode/index.tsx